export const eventsPlayer = [
    "canplay",
    "waiting",
    "ended",
    "pause",
    "playing"
];